<div [ngClass]="deviceService.ifMobile('subtitle-mobile').orElse('subtitle')">
    <ng-content></ng-content>
</div>
